import { render, staticRenderFns } from "./course-mapping.vue?vue&type=template&id=4275825c&scoped=true"
import script from "./course-mapping.vue?vue&type=script&lang=js"
export * from "./course-mapping.vue?vue&type=script&lang=js"
import style0 from "./course-mapping.css?vue&type=style&index=0&id=4275825c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4275825c",
  null
  
)

export default component.exports